export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const specialCharsRegex = /[!@#$%^&*(),.?":{}|<>]/;

export const createNotWhitespaceOnlyValidator = (errorMessage: string) => (value: string) =>
  /^\s*$/.test(value) ? errorMessage : true;

export const createNoSpecialCharsValidator = (errorMessage: string) => (value: string) =>
  specialCharsRegex.test(value) ? errorMessage : true;

export const createMaxLengthValidator = (maxLength: number, errorMessage: string) => (value: string) =>
  value.length > maxLength ? errorMessage : true;

export const createUniqueValidator = (existing: string[], errorMessage: string) => (value: string) =>
  existing.includes(value) ? errorMessage : true;
